import React from "react";
import { useParams } from "react-router-dom";
import CategoryItem from "../categoryItem";

const CategoryCarousel = ({ items }) => {
  let { categoryId } = useParams();

  if (items.length <= 1) return null;

  const renderedItems = items.map((item) => {
    return (
      <CategoryItem key={item.id} item={item} selectedCategoryId={categoryId} />
    );
  });

  return (
    <div className="category-row">
      <div className="category-wrapper">{renderedItems}</div>
    </div>
  );
};

export default CategoryCarousel;
